import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import axiosInstance from '../../utils/axiosInstance';
import { HiSearch } from 'react-icons/hi';

const Navbar = () => {
  const { isAuthenticated,  isAdmin } = useContext(AuthContext);
  const navigate = useNavigate();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [categories, setCategories] = useState([]);



  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosInstance.get('/categories');
        // Sort by sequence before setting state
        setCategories(response.data.sort((a, b) => a.sequence - b.sequence));
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    };
    fetchCategories();
  }, []);



  // --- SPLIT CATEGORIES FOR TWO NAVBARS ---
  const topNavCategories = categories.slice(0, 2);
  const subNavCategories = categories.slice(2);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/blogs?search=${searchQuery}`);
      setSearchQuery('');
      setIsMobileMenuOpen(false);
    }
  };
  
  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    // The <nav> now wraps both navbars
    <nav className="bg-gradient-to-r from-gray-800 via-gray-900 to-black text-white shadow-lg sticky top-0 z-50">
      {/* --- TOP NAVBAR --- */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-white font-bold text-2xl flex-shrink-0">StudyWeapon</Link>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-4">
                <Link to="/" className="nav-link">Home</Link>
                 <Link to="/download" className="nav-link">Download</Link>
                {/* <Link to="/blogs" className="nav-link">Articles</Link> */}
                {/* Renders the first 4 categories */}
                {topNavCategories.map(cat => (
                  <Link key={cat.id} to={`/blogs?category=${cat.id}`} className="nav-link">{cat.name}</Link>
                ))}
              </div>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <input type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder="Search..." className="search-input"/>
              <button type="submit" className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"><HiSearch size={20} /></button>
            </form>
            {/* --- IMPROVED BUTTON STYLES --- */}
            {isAuthenticated && isAdmin && (
              <>
                { <Link to="/admin" className="btn btn-dashboard">Dashboard</Link>}
                <Link to="/logout" className="btn btn-danger">Log Out</Link>
              </>
            )}
          </div>

          <div className="-mr-2 flex md:hidden">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} type="button" className="mobile-menu-button">
              <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                {isMobileMenuOpen ? ( <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /> ) : ( <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" /> )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* --- SUB-NAVBAR (for the rest of the categories) --- */}
      {subNavCategories.length > 0 && (
        <div className="hidden md:block bg-gray-700/50 backdrop-blur-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
                <div className="flex flex-row flex-wrap gap-x-4 gap-y-2">
                    {subNavCategories.map(cat => (
                        <Link key={cat.id} to={`/blogs?category=${cat.id}`} className="subnav-link">{cat.name}</Link>
                    ))}
                </div>
            </div>
        </div>
      )}

      {/* --- MOBILE MENU --- */}
      <div className={`${isMobileMenuOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          {/* Mobile links now render ALL categories in one list */}
          <Link to="/" className="mobile-nav-link" onClick={handleLinkClick}>Home</Link>
          <Link to="/blogs" className="mobile-nav-link" onClick={handleLinkClick}>Articles</Link>
          <hr className="border-gray-700 my-2"/>
          <p className="px-3 text-gray-400 text-sm font-semibold">Categories</p>
          {categories.map(cat => (
            <Link key={cat.id} to={`/blogs?category=${cat.id}`} className="mobile-nav-link" onClick={handleLinkClick}>{cat.name}</Link>
          ))}
          <hr className="border-gray-700 my-2"/>
          {/* Mobile Auth and Search */}
          {!isAuthenticated ? ( <>...</> ) : ( <>...</> )}
          <form onSubmit={handleSearch} className="flex p-2 gap-2">
            <input type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder="Search..." className="w-full bg-gray-700 text-white rounded-md py-2 px-3 focus:outline-none"/>
            <button type="submit" className="bg-green-600 p-2 rounded-md text-white"><HiSearch size={20} /></button>
          </form>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;